/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyEmailImport } from './routes/verify-email'
import { Route as SignupImport } from './routes/signup'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as RecoverPasswordImport } from './routes/recover-password'
import { Route as LoginImport } from './routes/login'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as BrowseClassesImport } from './routes/browse-classes'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutStudentsImport } from './routes/_layout/students'
import { Route as LayoutSettingsImport } from './routes/_layout/settings'
import { Route as LayoutSessionsImport } from './routes/_layout/sessions'
import { Route as LayoutSchoolSettingsImport } from './routes/_layout/schoolSettings'
import { Route as LayoutReportsImport } from './routes/_layout/reports'
import { Route as LayoutProfileImport } from './routes/_layout/profile'
import { Route as LayoutPaymentsImport } from './routes/_layout/payments'
import { Route as LayoutInvoicesImport } from './routes/_layout/invoices'
import { Route as LayoutHouseholdsImport } from './routes/_layout/households'
import { Route as LayoutHouseholdImport } from './routes/_layout/household'
import { Route as LayoutFilesImport } from './routes/_layout/files'
import { Route as LayoutEnrollmentsImport } from './routes/_layout/enrollments'
import { Route as LayoutEnrollImport } from './routes/_layout/enroll'
import { Route as LayoutDebugPermissionsImport } from './routes/_layout/debug-permissions'
import { Route as LayoutCoachImport } from './routes/_layout/coach'
import { Route as LayoutClassTemplatesImport } from './routes/_layout/classTemplates'
import { Route as LayoutClassSessionsImport } from './routes/_layout/classSessions'
import { Route as LayoutAttendancesImport } from './routes/_layout/attendances'
import { Route as LayoutAttendanceHistoryImport } from './routes/_layout/attendance-history'
import { Route as LayoutAdminImport } from './routes/_layout/admin'
import { Route as LayoutStudentsStudentIdAccountImport } from './routes/_layout/students_.$studentId.account'

// Create/Update Routes

const VerifyEmailRoute = VerifyEmailImport.update({
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any)

const SignupRoute = SignupImport.update({
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const RecoverPasswordRoute = RecoverPasswordImport.update({
  path: '/recover-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const BrowseClassesRoute = BrowseClassesImport.update({
  path: '/browse-classes',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudentsRoute = LayoutStudentsImport.update({
  path: '/students',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsRoute = LayoutSettingsImport.update({
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSessionsRoute = LayoutSessionsImport.update({
  path: '/sessions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSchoolSettingsRoute = LayoutSchoolSettingsImport.update({
  path: '/schoolSettings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReportsRoute = LayoutReportsImport.update({
  path: '/reports',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutProfileRoute = LayoutProfileImport.update({
  path: '/profile',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPaymentsRoute = LayoutPaymentsImport.update({
  path: '/payments',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInvoicesRoute = LayoutInvoicesImport.update({
  path: '/invoices',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutHouseholdsRoute = LayoutHouseholdsImport.update({
  path: '/households',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutHouseholdRoute = LayoutHouseholdImport.update({
  path: '/household',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutFilesRoute = LayoutFilesImport.update({
  path: '/files',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEnrollmentsRoute = LayoutEnrollmentsImport.update({
  path: '/enrollments',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEnrollRoute = LayoutEnrollImport.update({
  path: '/enroll',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDebugPermissionsRoute = LayoutDebugPermissionsImport.update({
  path: '/debug-permissions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutCoachRoute = LayoutCoachImport.update({
  path: '/coach',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutClassTemplatesRoute = LayoutClassTemplatesImport.update({
  path: '/classTemplates',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutClassSessionsRoute = LayoutClassSessionsImport.update({
  path: '/classSessions',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAttendancesRoute = LayoutAttendancesImport.update({
  path: '/attendances',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAttendanceHistoryRoute = LayoutAttendanceHistoryImport.update({
  path: '/attendance-history',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminRoute = LayoutAdminImport.update({
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutStudentsStudentIdAccountRoute =
  LayoutStudentsStudentIdAccountImport.update({
    path: '/students/$studentId/account',
    getParentRoute: () => LayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/browse-classes': {
      preLoaderRoute: typeof BrowseClassesImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/recover-password': {
      preLoaderRoute: typeof RecoverPasswordImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      preLoaderRoute: typeof VerifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/_layout/admin': {
      preLoaderRoute: typeof LayoutAdminImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/attendance-history': {
      preLoaderRoute: typeof LayoutAttendanceHistoryImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/attendances': {
      preLoaderRoute: typeof LayoutAttendancesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/classSessions': {
      preLoaderRoute: typeof LayoutClassSessionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/classTemplates': {
      preLoaderRoute: typeof LayoutClassTemplatesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/coach': {
      preLoaderRoute: typeof LayoutCoachImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/debug-permissions': {
      preLoaderRoute: typeof LayoutDebugPermissionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/enroll': {
      preLoaderRoute: typeof LayoutEnrollImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/enrollments': {
      preLoaderRoute: typeof LayoutEnrollmentsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/files': {
      preLoaderRoute: typeof LayoutFilesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/household': {
      preLoaderRoute: typeof LayoutHouseholdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/households': {
      preLoaderRoute: typeof LayoutHouseholdsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/invoices': {
      preLoaderRoute: typeof LayoutInvoicesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/payments': {
      preLoaderRoute: typeof LayoutPaymentsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/profile': {
      preLoaderRoute: typeof LayoutProfileImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reports': {
      preLoaderRoute: typeof LayoutReportsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/schoolSettings': {
      preLoaderRoute: typeof LayoutSchoolSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/sessions': {
      preLoaderRoute: typeof LayoutSessionsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings': {
      preLoaderRoute: typeof LayoutSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students': {
      preLoaderRoute: typeof LayoutStudentsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/students/$studentId/account': {
      preLoaderRoute: typeof LayoutStudentsStudentIdAccountImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  LayoutRoute.addChildren([
    LayoutAdminRoute,
    LayoutAttendanceHistoryRoute,
    LayoutAttendancesRoute,
    LayoutClassSessionsRoute,
    LayoutClassTemplatesRoute,
    LayoutCoachRoute,
    LayoutDebugPermissionsRoute,
    LayoutEnrollRoute,
    LayoutEnrollmentsRoute,
    LayoutFilesRoute,
    LayoutHouseholdRoute,
    LayoutHouseholdsRoute,
    LayoutInvoicesRoute,
    LayoutPaymentsRoute,
    LayoutProfileRoute,
    LayoutReportsRoute,
    LayoutSchoolSettingsRoute,
    LayoutSessionsRoute,
    LayoutSettingsRoute,
    LayoutStudentsRoute,
    LayoutIndexRoute,
    LayoutStudentsStudentIdAccountRoute,
  ]),
  BrowseClassesRoute,
  ForgotPasswordRoute,
  LoginRoute,
  RecoverPasswordRoute,
  RegisterRoute,
  ResetPasswordRoute,
  SignupRoute,
  VerifyEmailRoute,
])

/* prettier-ignore-end */
